import module from '@app/sesion/module'

module.config(($stateProvider) => {
  $stateProvider.state('sesion.terminada', {
    url: '',
    component: 'appSesionTerminada',
    data: {title: 'Sesión terminada'},
  })
})



// WEBPACK FOOTER //
// ./src/app/sesion/routes/sesion/terminada.js